export enum FileType {
  pdf = "pdf",
  doc = "doc",
  image = "image",
  video = "video",
  other = "other",
}

const DOC_MIME_TYPES = new Set([
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]);

export const getFileTypeFromMimeType = (
  mimeType?: string | null,
): FileType | undefined => {
  const normalizedMimeType = mimeType?.split(";")[0]?.trim().toLowerCase() ?? "";

  if (!normalizedMimeType) {
    return undefined;
  }

  if (normalizedMimeType === "application/pdf") {
    return FileType.pdf;
  }
  if (DOC_MIME_TYPES.has(normalizedMimeType)) {
    return FileType.doc;
  }
  if (normalizedMimeType.startsWith("image/")) {
    return FileType.image;
  }
  if (normalizedMimeType.startsWith("video/")) {
    return FileType.video;
  }

  return FileType.other;
};
